import { injectBaseConstantMethods } from "./BaseConstants";

export const NOTIFICATION_STATUS = {
    PENDING: "PENDING",
    SENT: "SENT"
};

const displayTextKeys = {
    [NOTIFICATION_STATUS.PENDING]: "Pending",
    [NOTIFICATION_STATUS.SENT]: "Sent"
};

const labelClass = {
    [NOTIFICATION_STATUS.PENDING]: "cs-badge-pending",
    [NOTIFICATION_STATUS.SENT]: "cs-badge-sent"
};

export default injectBaseConstantMethods(NOTIFICATION_STATUS, displayTextKeys, labelClass);
